<template>
  <div id="cannect-app">
    <div id="cannect-nav" :class="{ 'nav-dashboard' : $route.fullPath.includes('dashboard') || $route.fullPath.includes('userInfo') }">
      <meta name="viewport" content="width=device-width, maximum-scale=1, initial-scale=1" />
      <Navbar />
    </div>
    <div id="cannect-under-bar" :class="{ 'under-bar-dashboard' : $route.fullPath.includes('dashboard') || $route.fullPath.includes('userInfo') }" />
    <div id="cannect-main">
      <router-view />
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import config from './config'

export default {
  name: 'App',
  components: { Navbar },
  watch: {
    $route (to, _from) {
      this.$store.dispatch('triggerLocation', to.fullPath)
    }
  },
  created() {
    if (config.AT_INTERNET_SCRIPT_URL) {
      const atScript = document.createElement('script')
      atScript.setAttribute('type', 'text/javascript')
      atScript.setAttribute('src', config.AT_INTERNET_SCRIPT_URL)
      document.body.appendChild(atScript)
      atScript.onload = () => {
        this.$store.commit('setAtInternetTag')
      }
    }

    if (!document.getElementById('feedier-widget-script') && config.FEEDIER_URL) {
      const feedierScript = document.createElement('script')
      feedierScript.setAttribute('id', 'feedier-widget-script')
      feedierScript.setAttribute('type', 'text/javascript')
      feedierScript.setAttribute('src', config.FEEDIER_URL)
      feedierScript.setAttribute('async', '')

      document.body.appendChild(feedierScript)
    }
  }
}
</script>

<style lang="scss">
#cannect-app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: $app-background;
}

#cannect-under-bar {
  height: 192px; // Increased to account for potential maintenance banner

  @media (max-width: $medium) {
    height: 190px;
  }
}

#cannect-main {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  max-width: 100vw;
  overflow: visible;
  padding-top: 10px;
}

html,body{
  margin:0;
}

.noscroll {  overflow: hidden;  }
//TODO remove in future when its confirmed it is useless
//@media only print {
//  #nav, #under-bar {
//    display: none;
//  }
//
//  /* Fix for printing in Firefox */
//  #main {
//    height: auto;
//    overflow-y: hidden;
//    display: grid;
//  }
//}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: #F2F2F2;
  overflow: hidden;
}

#under-bar {
  height: 110px;
}

#nav {
  a {
    &.router-link-exact-active {
      font-weight: bold;
    }
  }
}

#main {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  max-width: 100vw;
  overflow: visible;
}

h1 {
  font-size: 40px;
}

h2 {
  font-size: 25px;
}

h3 {
  font-size: 18px;
}

h4 {
  font-size: 16px;
}

.bold {
  font-weight: 600;
}

.nav-dashboard {
  @media (max-width: $medium) {
    height: 70px;
  }
}

.under-bar-dashboard {
   @media (max-width: $medium) {
     height: 0px !important;
   }
}

</style>
